import React from 'react';

import './stylings/PageNotFound.css';

export default class PageNotFound extends React.Component {
	render () {
		return (
			<section className="container animated fadeIn">
				<h1 className="page-not-found-title">Seite nicht gefunden :(</h1>
			</section>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/PageNotFound.js